import { Mesh } from './mesh.js'
import { Shader } from './shader.js'
import { Texture } from './texture.js'
import { Model } from './model.js'
import axios from 'axios'

function DownlaodAsset(path, asset, responseType) {
  // create new request and its promise
  return axios
  .get(path, { responseType: responseType })
    .then(response => asset(response.data))
    .catch(error => console.log('Could not load the file: [' + path + ']', error));
}

function Assets() {
  var modelsPromises = [];

  // download assets
  var assets = [
    DownlaodAsset('animation/models/plane.json', Mesh, 'json'),
    DownlaodAsset('animation/shaders/plane.glsl', Shader, 'text'),
    Texture('animation/textures/words.png'),
  ];

  // create model from assets
  return Promise.all(assets).then(values => Model(values));
}

export { Assets };
